
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/vendors/[slug]",
      function () {
        return require("private-next-pages/vendors/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/vendors/[slug]"])
      });
    }
  